<template>
  <!-- <body id="mainmenu"> -->
    <div id="fullpage" v-cloak>
        <router-view :data="data" @goto="$parent.goto"></router-view>
        <transition name="fade">
        <videos @goto="$parent.goto($event)" v-show="$route.params.id>=0" :data="data"></videos>
        </transition>
    </div>
  <!-- </body> -->
</template>

<script>
const delay = t => new Promise(resolve => setTimeout(resolve, t));

import VideoComponent from './components/VideoComponent.vue'

export default {
  name: 'App',
  data () {
    return {
        data: {},
        showAlbum: false,
    }
  },
  components: {
    'videos': VideoComponent,
  },
  created: async function () {
    console.log("Created app")
    try {
          const url = process.env.NODE_ENV === 'production'  ? '/drupal/albertusfilm.json'  : '/albertusfilm.json';
          const data = await fetch(url + "?" + Math.random());
          let json = await data.json();
          //json.photoalbums = json.photoalbums.map(a => { return {...a, images: a.image.map(i => { return {src: i.url, thumbnail: i.url, w: i.width, h: i.height} }) }})
          if(process.env.NODE_ENV !== 'production') {
            json = JSON.parse(JSON.stringify(json).replace(/"\/drupal\//g,'"https://albertusfilm.dk/drupal/'))
          }
          console.log("App.vue",  json)
          this.data = json
      }
      catch (e) {
          console.error(e.message)
      }
  },
	async mounted() {
    // document.querySelector("#fullpage").style.backgroundImage="url(https://albertusfilm.dk/drupal/sites/default/files/styles/albertusbg/public/jabaggrundsbillede1.jpg?itok=5SGMMtTa) "
    document.querySelector("#fullpage").style.backgroundImage="url(https://albertusfilm.dk/drupal/sites/default/files/styles/albertusbg/public/jabaggrundsbillede1.jpg?itok=5SGMMtTa) "
    console.log(this.data)
    this.$nextTick(async function () {
      console.log("Nexttick")
      if(!this.data.background_images) await delay(350)
      const index = Math.floor(Math.random() * this.data.background_images.length) ;
      console.log(this.data.background_images)
      // document.querySelector("#fullpage").style.backgroundImage="url(" + this.data.background_images[index] + ")"
      document.querySelector("#fullpage").style.backgroundImage="url(" + this.data.background_images[index] + ")"
  })
  },
  computed: {
  },
  watch: {
    $route(to, from) {
      if (window.outerWidth <= 768 && from.name != "kontakt" && to.name != "kontakt" && to.name != "home") {
      //https://www.npmjs.com/package/vue-fullscreen
      // document.body.requestFullscreen()
      document.querySelector("#fullpage").requestFullscreen()
      }
    }
  }
}
</script>

<style>

#Xapp {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
